/**
 * Default user attribute data to be set on page view
 *
 * @type {{ member: boolean, reiccholder boolean }}
 */
export const CAAS_DEFAULT_USER_ATTRIBUTES = {
  member: false,
  reiccholder: false,
};
